<template>
  <div class="app-container">
    <Section heading="Subscriber Agreement" :mode="mode" />
    <AppCard :mode="mode">
      <template #body>
        <div class="flex flex-col gap-6 sm:gap-4">
          <div>
            <h2
              class="mb-5 text-[22px] font-semibold leading-none sm:text-[18px] sm:leading-[1.4]"
            >
              By Entering one's ID and Password you are Agreeing to the
              Following
            </h2>
            <div class="grid gap-2">
              <p
                class="text-[14px] font-medium"
                :class="[mode === 'dark' ? 'text-dark-text' : 'text-black-60']"
              >
                NETWORK COMMERCE INT'L, LLC, a Minnesota LLC, having its
                principal office at 131 NW First Ave, Delray Beach, Florida
                33444, (hereafter called "Provider")
              </p>
              <p
                class="text-[14px] font-medium"
                :class="[mode === 'dark' ? 'text-dark-text' : 'text-black-60']"
              >
                Entity entering their ID and Password (hereinafter called the
                "Subscriber").
              </p>
              <p
                class="text-[14px] font-medium"
                :class="[mode === 'dark' ? 'text-dark-text' : 'text-black-60']"
              >
                ITAD Association refers to the not for profit trade associations known
                as the Association of Service and Computer Dealers,
                International (ASCDI) and the North American Association of
                Telecommunications Dealers (NATD).
              </p>
              <p
                class="text-[14px] font-medium"
                :class="[mode === 'dark' ? 'text-dark-text' : 'text-black-60']"
              >
                BASED UPON the mutual covenants set forth, Subscriber agrees to
                the following:
              </p>
              <div class="flex flex-col gap-5">
                <div class="flex flex-col gap-2">
                  <h3 class="text-[18px] font-semibold">
                    <span>1 - </span> Services
                  </h3>
                  <p
                    class="text-[14px] font-medium"
                    :class="[
                      mode === 'dark' ? 'text-dark-text' : 'text-black-60',
                    ]"
                  >
                    During the term of this Agreement Provider will permit the
                    Subscriber to have access to the internet based network and
                    communications services operated by Provider hereafter
                    called "the NETWORK". Access will be available via the
                    internet transmitted to Provider's web server. Provider's
                    server is normally available for access 24 hours a day, 7
                    days a week. Subscriber must procure, operate, and maintain
                    all communication hardware and software necessary to access
                    the NETWORK. Provider is only responsible for the NETWORK
                    and the system operating the NETWORK.
                  </p>
                </div>
                <div class="flex flex-col gap-2">
                  <h3 class="text-[18px] font-semibold">
                    <span>2 - </span> Term
                  </h3>
                  <p
                    class="text-[14px] font-medium"
                    :class="[
                      mode === 'dark' ? 'text-dark-text' : 'text-black-60',
                    ]"
                  >
                    This Agreement shall remain in force until terminated in
                    accordance with the provisions of termination listed below.
                  </p>
                </div>
                <div class="flex flex-col gap-2">
                  <h3 class="text-[18px] font-semibold">
                    <span>3 - </span> Price / Payment
                  </h3>
                  <p
                    class="text-[14px] font-medium"
                    :class="[
                      mode === 'dark' ? 'text-dark-text' : 'text-black-60',
                    ]"
                  >
                    The Subscriber shall make payment to the Provider described
                    as follows. Price for the NETWORK Service is $100 per month
                    for ITAD Association Members and between $150-$175 per month for
                    Non ITAD Association Members. Provider may at any time change such
                    established price schedules. These prices do not include any
                    applicable sales, use, excise or similar taxes which may be
                    imposed by federal, state and local governments with respect
                    to the NETWORK. Subscriber is responsible for all taxes.
                  </p>
                  <p class="text-[14px] font-medium">
                    Subscriber will automatically be billed monthly via
                    Subscriber's Credit Card or via invoice. In the event any
                    invoice is not paid when due, Provider (reserving all other
                    remedies and rights under this Agreement and at law) at its
                    discretion, and with five (5) days prior written notice to
                    the Subscriber, may either suspend furnishing the NETWORK or
                    terminate this Agreement.
                  </p>
                </div>
                <div class="flex flex-col gap-2">
                  <h3 class="text-[18px] font-semibold">
                    <span>4 - </span> Use of Services
                  </h3>
                  <p
                    class="text-[14px] font-medium"
                    :class="[
                      mode === 'dark' ? 'text-dark-text' : 'text-black-60',
                    ]"
                  >
                    Subscriber shall enter ONLY accurate and genuine data with
                    regard to the buying or selling of IT and Telecom equipment
                    on NETWORK, and will not enter data or use the NETWORK for
                    any improper or illegal purpose. Improper data includes but
                    is not limited to the solicitation of employees, the making
                    of disparaging statements against others, polling users, the
                    sale of items other than technology equipment and/or the
                    marketing/promotion/solicitation of other trading networks
                    or trade associations other than the NETWORK and the
                    ITAD Association. Subscriber shall indemnify Provider from any loss
                    arising out of the improper use of NETWORK including the
                    publication of libelous material.
                  </p>
                  <p
                    class="text-[14px] font-medium"
                    :class="[
                      mode === 'dark' ? 'text-dark-text' : 'text-black-60',
                    ]"
                  >
                    Provider shall not exercise any right of prior review or
                    engage in censorship of any kind.
                  </p>
                </div>
                <div class="flex flex-col gap-2">
                  <h3 class="text-[18px] font-semibold">
                    <span>5 - </span> Rights in Data
                  </h3>
                  <p
                    class="text-[14px] font-medium"
                    :class="[
                      mode === 'dark' ? 'text-dark-text' : 'text-black-60',
                    ]"
                  >
                    All data entered by Subscriber and by other users of NETWORK
                    shall be considered "NETWORK Data". Use of the NETWORK Data
                    is limited to the Subscriber's internal use and distribution
                    only. NETWORK Data may not be republished, recompiled, or
                    disseminated for use by third parties for commercial
                    purposes. No license in Provider's software, programs, logo,
                    or systems is implied or intended.
                  </p>
                </div>
                <div class="flex flex-col gap-2">
                  <h3 class="text-[18px] font-semibold">
                    <span>6 - </span> Limitation of Liability & Warranty
                  </h3>
                  <p
                    class="text-[14px] font-medium"
                    :class="[
                      mode === 'dark' ? 'text-dark-text' : 'text-black-60',
                    ]"
                  >
                    Provider shall not be liable, on any theory of liability
                    whatsoever, for any incidental, special, indirect,
                    consequential or exemplary damages arising from use of the
                    NETWORK or the NETWORK Data. Provider makes no
                    representations, warranties, promises, statements or
                    affirmations as to the NETWORK or the NETWORK Data entered
                    therein or the performance thereof. ANY WARRANTIES IMPLIED
                    BY LAW ARE HEREBY DISCLAIMED AND EXCLUDED, INCLUDING WITHOUT
                    LIMITATION ANY IMPLIED WARRANTIES OF MERCHANTABILITY OR
                    FITNESS FOR A PARTICULAR PURPOSE.
                  </p>
                </div>
                <div class="flex flex-col gap-2">
                  <h3 class="text-[18px] font-semibold">
                    <span>7 - </span> Ethics Code
                  </h3>
                  <p
                    class="text-[14px] font-medium"
                    :class="[
                      mode === 'dark' ? 'text-dark-text' : 'text-black-60',
                    ]"
                  >
                    Subscriber agrees to be bound by the code of ethics of the
                    ITAD Association including participation in any ethics review
                    process. Failure to do so may result in removal from the
                    NETWORK Network. A copy of said Ethics Code is available on
                    line at www.ascdi.com and
                    <a
                      href="https://www.natd.com"
                      target="_blank"
                      class="break-words text-primary-100"
                      >www.natd.com</a
                    >
                    Any Subscriber who is using the NETWORK including those who
                    are using the network on a trial basis, may be removed from
                    the NETWORK should the ITAD Association receive an ethics complaint
                    against them, pending resolution of said complaint.
                  </p>
                </div>
                <div class="flex flex-col gap-2">
                  <h3 class="text-[18px] font-semibold">
                    <span>8 - </span> Governing Law
                  </h3>
                  <p
                    class="text-[14px] font-medium"
                    :class="[
                      mode === 'dark' ? 'text-dark-text' : 'text-black-60',
                    ]"
                  >
                    This Agreement will be governed by and construed in
                    accordance with the laws of Minnesota, USA. Neither this
                    Agreement nor any rights or obligations under this Agreement
                    may be assigned or otherwise transferred by the Subscriber
                    without the prior written consent of Provider.
                  </p>
                </div>
                <div class="flex flex-col gap-2">
                  <h3 class="text-[18px] font-semibold">
                    <span>9 - </span> Termination
                  </h3>
                  <p
                    class="text-[14px] font-medium"
                    :class="[
                      mode === 'dark' ? 'text-dark-text' : 'text-black-60',
                    ]"
                  >
                    The Subscriber may terminate this Agreement upon fifteen
                    (15) days prior written notice to Provider in the event
                    Provider changes its established price schedule. Provider
                    may terminate this Agreement for nonpayment of charges or
                    for other substantial cause upon five (5) days prior written
                    notice. Either party may terminate this Agreement without
                    cause as of the first day of any month by giving thirty (30)
                    days prior written notice.
                  </p>
                </div>
                <div class="flex flex-col gap-2">
                  <h3 class="text-[18px] font-semibold">
                    <span>10 - </span> Entire Agreement
                  </h3>
                  <p
                    class="text-[14px] font-medium"
                    :class="[
                      mode === 'dark' ? 'text-dark-text' : 'text-black-60',
                    ]"
                  >
                    This Agreement supersedes any and all prior representations,
                    conditions, warranties, understandings, proposals, or
                    previous agreements between the parties hereto, oral or
                    written, in relation to the NETWORK, including without
                    limitation, the terms of any purchase order submitted by the
                    Subscriber, and constitutes the sole, full and complete
                    Agreement between the parties hereto.
                  </p>
                  <p
                    class="text-[14px] font-medium"
                    :class="[
                      mode === 'dark' ? 'text-dark-text' : 'text-black-60',
                    ]"
                  >
                    Subscriber acknowledges that they understand and agree to
                    this Subscription Agreement in its entirety.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
    </AppCard>
  </div>
</template>

<script>
import AppCard from "@C/Common/AppCard.vue";
import Section from "@C/Common/Section.vue";

export default {
  name: "Agreement",
  components: {
    Section,
    AppCard,
  },
  props: {
    mode: String,
  },
};
</script>
